import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import {TermsData} from './TermsData';

const TermsAndPrivacy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Content */}
      <TermsData />
      {/* Footer */}
      <div className="bg-black text-white py-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-gray-300">
            © 2025 Gomens. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndPrivacy;